































































import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator';

import sleep from '../../../utils/sleep';


type ring_t = {
    idx: number,
    letters: string[],
    offset: number,
};


const DEF_LETTERS = () => ([
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
]);



@Component({
    components: {
    },
})
export default class CryptexVue extends Vue {

    @Ref('cryptex') ref_cryptex!: HTMLElement;

    // The code that solves the cryptex
    @Prop({default: '123'})
    private code!: string;

    @Prop({default: DEF_LETTERS})
    private letters!: string[];

    private rings:ring_t[] = [];

    private scaleCryptex:number = 0.5;

    private enabled = true;

    created() {
        window.addEventListener("resize", this.onResize);
    }

    destroyed() {
        window.removeEventListener("resize", this.onResize);
    }

    mounted(){

        this.rings = Array(this.code.length).fill(null).map(x => ({
            idx:0,
            letters: ['1', '2', '3', '4', '5', '6', '7'],
            offset: 0,
        }));

        this.updateScaleCryptex();

    }


    get innerWidth(){

        let width = 167 * 2 + 20 + (20 + 50) * this.rings.length;

        return width;

    }


    updateScaleCryptex(){

        let width =  this.ref_cryptex.clientWidth / this.innerWidth;

        this.scaleCryptex = width;

    }

    onResize(){
        this.updateScaleCryptex();
    }


    rotate(idx:number, up:boolean){

        if(!this.enabled) return;

        let offset = this.rings[idx].offset;
        
        offset += (up ? -1 : +1);
        offset += this.letters.length;
        offset %= this.letters.length;

        this.rings[idx].offset = offset;

        if(this.current.toLowerCase() === this.code.toLowerCase()){
            this.show_success();
        }
        
    }

    letter(idx:number, pos:number){

        const start = -2;
        let offset = this.rings[idx].offset;

        offset += start + pos + this.letters.length;
        offset %= this.letters.length;

        return this.letters[offset];

    }

    get current(){

        return this.rings.map((r,i) => {
            return this.letter(i, 2);
        }).join('');

    }



    // Show sucess and emit
    async show_success(){

        this.enabled = false;

        await sleep(1000);

        this.$emit('success');

    }

   
}

